import { UploadFileOutlined } from "@mui/icons-material";
import { Button, Typography, styled } from "@mui/material";
import React from "react";
import { Controller, RegisterOptions } from "react-hook-form";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

interface Props {
    name: string,
    label: string,
    registerOptions?: RegisterOptions<any, any>
}

const SHFormFileUpload : React.FC<Props> = ({name, label, registerOptions}) => {
    return <>
    <Controller name={name} rules={registerOptions} render={({field}) => <><Button
  component="label"
  role={undefined}
  variant="contained"
  tabIndex={-1}
  startIcon={<UploadFileOutlined />}
>
  {label}
  <VisuallyHiddenInput name={field.name} type="file" accept="pdf" value={field?.value?.filename} onChange={(event) => field.onChange(event?.target?.files)} />
</Button>
<Typography variant="body2">{field.value !== undefined ? `File added` : ''}</Typography>
</>} />
        
    </>
}

export default SHFormFileUpload;